import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, Row } from "reactstrap";
import QRCode from "qrcode.react";
import _ from "lodash";

import usersIcon from "assets/images/activities/users-icon.png";
import backIcon from "assets/images/sbs/sbs-wellness/well-back.png";
import squeezeActImg from "assets/images/activities/act-squeeze.png";
import Footer from "pages/landingLibrary/Footer";
import SideBarTabs from "pages/landingLibrary/sideBarTabs";
import ActivityHeader from "pages/activities/components/ActivityHeader";
import { setIsLoading } from "redux/loader/action";
import { getSubGameData } from "redux/gameParams/actions";
import { setWellnessParamsOnject, set_view_activity } from "redux/game/action";
import Socket from "socket/socket";

const WellnessLibrary = (props) => {
  const dispatch = useDispatch();
  const gameReducer = useSelector((state) => state.gameReducer);
  const link = _.get(gameReducer, "roomObj.branch_url");
  const view_activity = _.get(gameReducer, "view_activity");
  const roomData = _.get(gameReducer, "roomObj");
  const wellnessActivities = roomData?.game_state?.activities;
  const status = _.get(gameReducer, "roomObj.game_state.status");
  const current_user = _.get(gameReducer, "currentUser");
  const team = _.get(current_user, "team");
  const teamCode = _.get(team, "id");
  const session_id = _.get(gameReducer, "session_id");
  const sessionObj = _.get(gameReducer, "sessionObj");
  const game_library = _.get(gameReducer, "gamesData.game_library_v2");
  const team_session_params = _.get(game_library, "team_session");
  const squeezes = _.get(game_library, "browse.squeezes.activities");
  const sub_squeeze = _.get(roomData, "game_state.activity");

  const current_squeeze = squeezes.find(
    (item) =>
      item.game_code === roomData.game_code &&
      item.edition === roomData?.game_state?.activity_category
  );

  const [goingUp, setGoingUp] = useState(false);

  const handleIsLoading = (value) => dispatch(setIsLoading(value));

  useEffect(() => {
    return Socket.addListener(
      "update-status",
      handle_update_status,
      handle_update_status_error
    );
  }, []);

  const handle_update_status = (res) => {
    if (res.activityId || res.destination === "Options") handleIsLoading(false);
    if (res.room.game_state.status === "Over") backToLobbyWelness();
  };

  const handle_update_status_error = () => handleIsLoading(false);

  const backToWellnessLibrary = () => {
    handleIsLoading(true);
    let data = {
      action: "update-status",
      roomId: roomData.id
    };
    Socket.sendMessage(data);
  };

  const backToLobbyWelness = () => {
    let data = {
      action: "update-status",
      roomId: roomData.id,
      destination: "Options"
    };
    Socket.sendMessage(data);
  };

  const onStartGame = async (activity) => {
    handleIsLoading(true);
    let data = {
      action: "update-status",
      roomId: roomData.id,
      activityId: activity?.id
    };
    Socket.sendMessage(data);
    await getSubGameData({ game_code: "SBS" });
  };

  const handleBack = () => {
    setWellnessParamsOnject({});
    props.history.replace("/activities");
  };

  const handleBackToLobby = () => {
    if (status === "Options") {
      handleBack();
    } else if (status === "Play") {
      backToWellnessLibrary();
    }
  };

  return (
    <Row style={{ marginRight: 0 }}>
      <Col md={1} lg={1} className="p-0">
        <SideBarTabs
          current_user={current_user}
          handleOptClick={() => props.history.push("/outside_team_building")}
        />
      </Col>
      <Col md={11} lg={11}>
        <main className="wellness-main">
          <ActivityHeader
            wellness={true}
            history={props.history}
            activity_name={view_activity?.activity?.label}
            handleActivitiesClick={() => set_view_activity({})}
          />
          <button className="activities-back-btn wellness" onClick={handleBack}>
            Back
          </button>
          <section className="wellness-wrapper">
            <div className="wellness-type">
              <div className="first-div">
                <h2>
                  {!sub_squeeze ? roomData?.title : sub_squeeze.activity_name}
                </h2>
              </div>
              <div className="second-div">
                <div className="me-5">
                  <p>wellness</p>
                </div>
                <div className="d-flex align-item-center me-5">
                  <img src={usersIcon} className="img-fluid icon1" alt="" />
                  <p>1-20 teammates</p>
                </div>
                <div className="d-flex align-item-center">
                  <img src={squeezeActImg} className="img-fluid icon2" alt="" />
                  <p>squeeze</p>
                </div>
              </div>
            </div>
            <div className="wellness-data">
              <div className="image">
                <img
                  src={
                    !sub_squeeze ? current_squeeze?.logo : sub_squeeze.card_img
                  }
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="content">
                <h2>Overview</h2>
                <p className="desc">
                  {!sub_squeeze
                    ? roomData?.description
                    : sub_squeeze.description}
                </p>
                <div className="options-wrapper">
                  <div>
                    <div className="option lobby" onClick={handleBackToLobby}>
                      <img src={backIcon} className="img-fluid img1" alt="" />
                    </div>
                    <p>Back to Lobby</p>
                  </div>
                  <div>
                    <div className="option">
                      <h3 className="code">{roomData?.join_code}</h3>
                    </div>
                    <p> Join Code</p>
                  </div>
                  <div>
                    <div className="option">
                      <QRCode
                        value={link && link !== "" ? link : "Loading"}
                        size={100}
                        bgColor="transparent"
                        fgColor="#18154D"
                      />
                    </div>
                    <p>Scan to Join</p>
                  </div>
                </div>
              </div>
            </div>
            <p className="select-ex">
              {!sub_squeeze ? "Select an Exercise" : "Start Exercise"}
            </p>

            {(status === "Play" || status === "Over") && (
              <div className="wellness-video">
                <video
                  controls
                  onEnded={backToWellnessLibrary}
                  poster={sub_squeeze.background_img}
                >
                  <source
                    src={roomData.game_state.activity.media_file}
                    type="video/mp4"
                  />
                </video>
                {/* <div className="play-btn">
                    <img src={playBtn} className="img-fluid" alt="playBtn" />
                  </div> */}
              </div>
            )}

            {status === "Options" && (
              <Row className="wellness-row">
                {!_.isEmpty(wellnessActivities) &&
                  wellnessActivities.map((activity) => (
                    <Col key={activity.id} md={6} lg={4}>
                      <div
                        className="select-wellness-card"
                        tabIndex="-1"
                        style={{ width: "100%", display: "inline-block" }}
                      >
                        <div className="game-img">
                          <img
                            alt=""
                            src={activity.card_img}
                            className="img-fluid img"
                          />
                          <div className="bg-layer">
                            <h3>{activity.activity_name}</h3>
                          </div>
                        </div>
                        <div className="game-info">
                          <div>
                            <h4 className="text1">wellness</h4>
                            <div className="d-flex align-items-center">
                              <img className="img-fluid userImg1" alt="" />
                              <img className="img-fluid userImg me-2" alt="" />
                            </div>

                            <p className="desc">{`${
                              activity.description.length > 150
                                ? activity.description.substring(0, 150) + "..."
                                : activity.description
                            }`}</p>
                          </div>
                          <span
                            className="view-link"
                            onClick={() => onStartGame(activity)}
                          >
                            View Excercise
                          </span>
                        </div>
                      </div>
                    </Col>
                  ))}
              </Row>
            )}
          </section>
        </main>
      </Col>

      {!_.isEmpty(current_user?.team) && (
        <Footer
          link={link}
          goingUp={goingUp}
          teamCode={teamCode}
          sessionId={session_id}
          sessionUsers={sessionObj?.users}
          team_session={team_session_params}
        />
      )}
    </Row>
  );
};

export default WellnessLibrary;
